/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Calc_Row_AsanaInputs */

const en_mk_calc_row_asana = /** @type {(inputs: Mk_Calc_Row_AsanaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asana Advanced`)
};

const id_mk_calc_row_asana = /** @type {(inputs: Mk_Calc_Row_AsanaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asana Advanced`)
};

/**
* | output |
* | --- |
* | "Asana Advanced" |
*
* @param {Mk_Calc_Row_AsanaInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_calc_row_asana = /** @type {((inputs?: Mk_Calc_Row_AsanaInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Calc_Row_AsanaInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_calc_row_asana(inputs)
	return en_mk_calc_row_asana(inputs)
});